import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Label } from "../../../backend/backendapi";
import { KanbanState } from "../../kanban.model";

@Component({
    name: 'LabelModal',
    components: {}
})
export default class LabelModal extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    state!: KanbanState;
    @Prop({ required: true })
    exclude!: Label[];

    private get unassignedLabels(): Label[] {
        let ex = this.exclude.map(e => e.id);
        return this.state.labels.filter(e => !ex.includes(e.id));
    }

    private get assignedLabels(): Label[] {
        let ex = this.exclude.map(e => e.id);
        return this.state.labels.filter(e => ex.includes(e.id));
    }

    private close(): void {

    }

    private add(label: Label): void {
        this.$emit('addLabel', label);
    }

    private remove(label: Label): void {
        this.$emit('removeLabel', label);
    }
}